/**
 * Auth.tsx
 * This is the auth layout of all authentication pages.
 */

import React, { useEffect, useState } from "react";
import Styles from "./layout.module.css";
import AuthUtil from "../../utils/auth";

interface AuthComponentProps {
  children: React.ReactNode; // Define the type for children
}

export default function AuthComponent({ children }: AuthComponentProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [state, setState] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      if (AuthUtil.isTokenExist()) {
        setState(true);
        window.location.href = "/dashboard";
      } else {
        setIsAuthenticated(true);
      }
    };
    checkAuthentication();
  }, [isAuthenticated]);

  if (state) {
    return null;
  }

  return isAuthenticated ? (
    <div className={Styles.authLayout}>
      <div className={Styles.pages}>
        {/* <div className={Styles.logoContainer}>
          <img
            src={"/assets/images/logo.png"}
            alt="logo"
            style={{
              width: "200px",
              height: "auto",
              marginBottom: "10px",
            }}
          />
        </div> */}
        {children}
      </div>
      <div className={Styles.backgroundImage}></div>
    </div>
  ) : (
    <></>
  );
}
